import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { ContractDocument } from 'shared/types';

export function useGetContract(id?: string) {
  const { contractService } = useService();
  const { data, isLoading, isFetching } = useQuery<ContractDocument | undefined, Error>(
    ['contract', id],
    () => contractService.getContract(id),
    {
      enabled: Boolean(id),
    }
  );

  return { contract: data, isLoading, isFetching } as const;
}
